import getLevel from './get-level';

export function getGridName(id) {
  return `${id}Grid`;
}

export function getGridRoute({
  CampaignId,
  AdGroupId,
}, path) {
  const level = getLevel({
    CampaignId,
    AdGroupId,
  });

  switch (level) {
    case 'AdGroup':
      return `customer/:customer_id/account/:account_id/campaign/:campaign_id/adgroup/:adgroup_id/dimensions/${path}`;
    case 'Campaign':
      return `customer/:customer_id/account/:account_id/campaign/:campaign_id/dimensions/${path}`;
    case 'Account':
    default:
      return `customer/:customer_id/account/:account_id/dimensions/${path}`;
  }
}

export function getTimeGridRoute(selection, path) {
  return getGridRoute(selection, `time/${path}`);
}

export function getShoppingGridRoute(selection, path) {
  return getGridRoute(selection, `shopping/${path}`);
}
